export default "__VITE_ASSET__DsVNC7bF__"